<template>
  <nav v-if="step === 'successLoggedIn'"
       class="navbar navbar-expand-md navbar-light bg-light justify-content-center fixed-top">
    <a class="navbar-brand" href="#">
      <img src="../assets/logo32.png" class="d-inline-block align-top" alt="">
    </a>
    <h6 class="my-0 font-weight-normal text-dark">{{ login }}</h6>
    <button class="btn btn-sm btn-danger mx-3" type="button" @click="signOut">Выход</button>
  </nav>
  <div v-else-if="step === 'directLogin'" class="form-signin text-center">
    <img class="mb-4" src="../assets/logo.png" alt="">
    <h1 class="h3 mb-3 font-weight-normal">CyberConstructor</h1>
    <div class="text-center text-warning my-2">
      <b-spinner class="align-middle"></b-spinner>
    </div>
  </div>
  <div v-else-if="step !== 'successLoggedInDirect'" class="form-signin text-center">
    <img class="mb-4" src="../assets/logo.png" alt="">
    <h1 class="h3 mb-3 font-weight-normal">CyberConstructor</h1>

    <form v-if="step === 'checkLogin'" class="form-signin text-center" @submit.prevent="checkLogin">
      <input v-model.trim="login" v-bind:class="{ 'is-invalid': invalidLogin }" type="text" id="identifier"
             name="identifier"
             class="form-control"
             placeholder="E-mail или Логин"
             required autofocus tabindex="0" autocomplete="username" spellcheck="false" autocapitalize="none">
      <label for="identifier" class="sr-only">E-mail или Логин</label>
      <span v-show="invalidLogin" v-bind:class="{ 'invalid-feedback': invalidLogin }">
                Такого пользователя не существует
            </span>
      <hr/>
      <button class="btn btn-lg btn-primary btn-block" type="submit">Войти</button>
    </form>
    <template v-if="step === 'signUp'">
      <h6 class="my-0 font-weight-normal">{{ login }}</h6>
      <form class="form-signin text-center" @submit.prevent="signUp">
        <input v-model="password" v-bind:class="{ 'is-invalid': invalidPassword }" type="password"
               id="password" name="password"
               class="form-control"
               placeholder="Введите пароль"
               required autofocus tabindex="0" autocomplete="current-password" spellcheck="false"
               autocapitalize="off">
        <label for="password" class="sr-only">Введите пароль</label>
        <span v-show="invalidPassword" v-bind:class="{ 'invalid-feedback': invalidPassword }">
                Неверный пароль
                </span>
        <hr/>
        <button class="btn btn-lg btn-danger btn-block" type="submit">Войти</button>
        <button class="btn btn-sm btn-primary btn-block" @submit.prevent="" @click.prevent="exit">
          Вернуться назад
        </button>
      </form>
    </template>
    <template v-if="step === 'handleNewPassword'">
      <h6 class="my-0 font-weight-normal">{{ login }}</h6>
      <form class="form-signin text-center" @submit.prevent="handleNewPassword">
        <input v-model="newPassword" v-bind:class="{ 'is-invalid': invalidPassword }" type="password"
               id="newPassword" name="newPassword"
               class="form-control"
               placeholder="Задайте новый пароль"
               required autofocus tabindex="0" spellcheck="false" autocapitalize="off">
        <label for="newPassword" class="sr-only">Задайте новый пароль</label>
        <span v-show="invalidPassword" v-bind:class="{ 'invalid-feedback': invalidPassword }">
                    Пароль должен быть не менее 6 символов
                </span>
        <input v-model="confirmNewPassword" v-bind:class="{ 'is-invalid': invalidConfirmPassword }"
               type="password"
               id="confirmNewPassword" name="confirmNewPassword"
               class="form-control"
               placeholder="Повторите новый пароль"
               required autofocus tabindex="1" spellcheck="false" autocapitalize="off">
        <label for="confirmNewPassword" class="sr-only">Повторите новый пароль</label>
        <span v-show="invalidConfirmPassword" v-bind:class="{ 'invalid-feedback': invalidConfirmPassword }">
                    Предложенные пароли не совпадают
                </span>
        <hr/>
        <button class="btn btn-lg btn-warning btn-block" type="submit">Сменить пароль</button>
        <button class="btn btn-sm btn-primary btn-block" @submit.prevent="" @click.prevent="exit">
          Вернуться назад
        </button>
      </form>
    </template>
    <span>
      Доступно для авторизованных пользователей
    </span>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  props: {
    userId: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      login: this.userId,
      password: this.userId,
      invalidLogin: false,
      invalidPassword: false,
      newPassword: '',
      confirmNewPassword: '',
      invalidConfirmPassword: false,
      step: 'directLogin',
    }
  },
  created: function () {
    if (this.userId === '') {
      this.checkSession();
    } else {
      this.signUp();
    }
  },
  computed: {
    cognitoConfig() {
      return {
        cognito: {
          userPoolId: 'us-east-1_pXtgD9VlN',
          userPoolClientId: '5v7jc8hrf9it17761892sgm4vr',
          region: 'us-east-1'
        },
      }
    },
    poolData() {
      return {
        UserPoolId: this.cognitoConfig.cognito.userPoolId,
        ClientId: this.cognitoConfig.cognito.userPoolClientId
      }
    },
  },
  methods: {
    checkSession() {
      let AmazonCognitoIdentity = require('amazon-cognito-identity-js');
      let userPool = new AmazonCognitoIdentity.CognitoUserPool(this.poolData);
      let cognitoUser = userPool.getCurrentUser();

      if (cognitoUser != null) {
        let vm = this;
        cognitoUser.getSession(function (err, session) {
          if (!err && session.isValid()) {
            cognitoUser.getUserAttributes(function (err2, attributes) {
              if (!err2) {
                vm.login = attributes.find(value => value.getName().toLowerCase() === 'email').getValue();
                vm.successLoggedIn(cognitoUser.getSignInUserSession().getIdToken().getJwtToken());
              } else {
                vm.step = 'checkLogin';
              }
            });
          } else {
            vm.step = 'checkLogin';
          }
        });
      } else {
        this.step = 'checkLogin';
      }
    },
    successLoggedIn(authorizationToken) {
      this.step = this.userId === '' ? 'successLoggedIn' : 'successLoggedInDirect';
      this.$emit('loggedIn', authorizationToken);
      $("body").removeClass('body-login');
    },
    logIn(newPasswordRequiredCallback) {
      let AmazonCognitoIdentity = require('amazon-cognito-identity-js');

      let authenticationData = {
        Username: this.login,
        Password: this.password,
      };
      let authenticationDetails = new AmazonCognitoIdentity.AuthenticationDetails(authenticationData);
      let userPool = new AmazonCognitoIdentity.CognitoUserPool(this.poolData);
      let userData = {
        Username: this.login,
        Pool: userPool
      };
      let vm = this;
      let cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
      cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: function () {
          cognitoUser.setDeviceStatusRemembered({
            onSuccess: function () {
              //  ignore
            },
            onFailure: function () {
              //  ignore
            }
          });
          vm.successLoggedIn(cognitoUser.getSignInUserSession().getIdToken().getJwtToken());
        },
        onFailure: function () {
          vm.invalidPassword = true;
          vm.password = '';
          vm.step = 'signUp';
        },
        mfaRequired: function () {
          //  ignore
        },
        newPasswordRequired: function (userAttributes) {
          newPasswordRequiredCallback(cognitoUser, userAttributes);
        }
      });
    },
    checkLogin() {
      let AmazonCognitoIdentity = require('amazon-cognito-identity-js');

      let authenticationData = {
        Username: this.login,
        Password: '1234',
      };
      let authenticationDetails = new AmazonCognitoIdentity.AuthenticationDetails(authenticationData);
      let userPool = new AmazonCognitoIdentity.CognitoUserPool(this.poolData);
      let userData = {
        Username: this.login,
        Pool: userPool
      };
      let vm = this;
      let cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
      cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: function () {
          //  ignore
        },
        onFailure: function (err) {
          vm.invalidLogin = (err.code === 'UserNotFoundException');
          if (!vm.invalidLogin) {
            vm.step = 'signUp';
          }
        },
      });
    },
    signUp() {
      let vm = this;
      this.logIn(function () {
            vm.step = 'handleNewPassword';
          }
      )
    },
    handleNewPassword() {
      this.invalidPassword = (this.newPassword.length < 6);
      if (this.invalidPassword) {
        this.newPassword = '';
        this.confirmNewPassword = '';
        this.invalidConfirmPassword = false;
        return;
      }
      this.invalidConfirmPassword = (this.newPassword !== this.confirmNewPassword);
      if (this.invalidConfirmPassword) {
        this.confirmNewPassword = '';
        return;
      }

      let vm = this;
      this.logIn(function (cognitoUser, userAttributes) {
        delete userAttributes.email_verified;
        cognitoUser.completeNewPasswordChallenge(vm.newPassword, userAttributes, {
          onSuccess: function () {
            vm.password = vm.newPassword;
            vm.logIn();
          },
          onFailure: function () {
            //  ignore
          }
        });
      });
    },
    exit() {
      this.password = '';
      this.newPassword = '';
      this.confirmNewPassword = '';
      this.invalidLogin = false;
      this.invalidPassword = false;
      this.invalidConfirmPassword = false;
      this.step = 'checkLogin';
      this.$emit('loggedIn', '');
      $("body").addClass('body-login');
    },
    signOut() {
      let AmazonCognitoIdentity = require('amazon-cognito-identity-js');
      let userPool = new AmazonCognitoIdentity.CognitoUserPool(this.poolData);
      let cognitoUser = userPool.getCurrentUser();
      cognitoUser.signOut();
      this.exit();
    }
  }
}
</script>